import { PrintDoc } from '../print/PrintDoc';
import { fmt } from '../shared/badges';
import { getBranding } from '../../lib/branding';

const th = 'border border-slate-400 px-2 py-1 text-[9px] font-bold uppercase tracking-[0.06em] text-slate-600';
const td = 'border border-slate-300 px-2 py-1.5 font-data text-[11px]';

// Certificat de retenue à la source — conforme à la présentation de l'État tunisien :
// en-tête organisme payeur / bénéficiaire, tableau détaillé, pied cachet & signature.
export const CertificatRS = ({ depense, fournisseur, onClose }) => {
  const b = getBranding();
  const datePaiement = (depense.reglements ?? []).slice(-1)[0]?.date ?? depense.date;
  return (
    <PrintDoc
      type="Certificat de retenue à la source"
      numero={`CRS-${depense.numero}`}
      date={datePaiement}
      lignes={[]}
      totaux={[
        ['Montant brut (base de la retenue)', `${fmt(depense.montantTTC, 3)} TND`],
        ['Retenue opérée', `${fmt(depense.montantRS, 3)} TND`],
        ['Montant net payé au bénéficiaire', `${fmt(depense.netAPayer, 3)} TND`],
      ]}
      mentions="Certificat délivré en application du Code de l'impôt sur le revenu des personnes physiques et de l'impôt sur les sociétés (art. 52 et suivants). La retenue opérée est reversée au Trésor et télédéclarée sur la plateforme TEJ au titre du mois du paiement. Ce certificat doit être joint par le bénéficiaire à sa déclaration fiscale."
      signatures={['Cachet & signature — Organisme payeur', 'Signature — Bénéficiaire']}
      onClose={onClose}
      enfants={
        <>
          <section className="mt-4 grid grid-cols-2 gap-3">
            <div data-testid="crs-payeur" className="border border-slate-400 px-3 py-2">
              <p className="text-[9px] font-bold uppercase tracking-[0.12em] text-slate-500">Organisme payeur</p>
              <p className="font-heading text-sm font-bold">{b.nom}</p>
              <p className="font-data text-[11px] text-slate-700">Matricule fiscal : {b.mf || '________________'}</p>
              <p className="font-data text-[11px] text-slate-700">{b.adresse || 'Sfax — Tunisie'}</p>
              <p className="font-data text-[11px] text-slate-700">Tél. {b.tel}</p>
            </div>
            <div data-testid="crs-beneficiaire" className="border border-slate-400 px-3 py-2">
              <p className="text-[9px] font-bold uppercase tracking-[0.12em] text-slate-500">Bénéficiaire de la somme</p>
              <p className="font-heading text-sm font-bold">{depense.fournisseur}</p>
              <p className="font-data text-[11px] text-slate-700">
                {fournisseur?.mf ? `Matricule fiscal : ${fournisseur.mf}` : fournisseur?.cin ? `CIN : ${fournisseur.cin}` : 'Matricule / CIN : ________________'}
              </p>
              <p className="font-data text-[11px] text-slate-700">{fournisseur?.adresse || fournisseur?.region || '—'}</p>
              <p className="font-data text-[11px] text-slate-700">Tél. {fournisseur?.tel || '—'}</p>
            </div>
          </section>

          <table className="mt-4 w-full border-collapse text-left" data-testid="crs-tableau">
            <thead>
              <tr className="bg-slate-100">
                {['Date de paiement', 'Nature de la retenue', 'N° facture', 'Montant base (TTC)', 'Taux', 'Montant retenu', 'Montant net'].map((c) => (
                  <th key={c} className={th}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={td}>{datePaiement}</td>
                <td className={td}>{depense.categorie}{depense.libelle ? ` — ${depense.libelle}` : ''}</td>
                <td className={`${td} font-semibold`}>{depense.numeroFacture}</td>
                <td className={`${td} tabular text-right`}>{fmt(depense.montantTTC, 3)}</td>
                <td className={`${td} text-right`}>{String(depense.tauxRS).replace('.', ',')} %</td>
                <td className={`${td} tabular text-right font-bold`}>{fmt(depense.montantRS, 3)}</td>
                <td className={`${td} tabular text-right font-bold`}>{fmt(depense.netAPayer, 3)}</td>
              </tr>
            </tbody>
          </table>

          <table className="mt-3 w-full border-collapse text-left" data-testid="crs-detail-facture">
            <tbody>
              {[
                ['Montant HT', fmt(depense.montantHT, 3)],
                ['Autres taxes (FODEC…)', fmt(depense.autresTaxes ?? 0, 3)],
                ['Base soumise à TVA', fmt(depense.baseTVA ?? depense.montantHT, 3)],
                [`TVA ${String(depense.tauxTVA).replace('.', ',')} %`, fmt(depense.montantTVA, 3)],
                ['Timbre fiscal', fmt(depense.timbreFiscal ?? 0, 3)],
                ['Montant TTC de la facture', fmt(depense.montantTTC, 3)],
              ].map(([k, v]) => (
                <tr key={k} className="border-b border-slate-200">
                  <th className="w-2/3 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.06em] text-slate-500">{k}</th>
                  <td className="tabular px-2 py-1 text-right font-data text-[11px] font-semibold">{v} TND</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      }
    />
  );
};
